import OpenDebitCardMailingV2 from './OpenDebitCardMailingV2';

export default OpenDebitCardMailingV2;
